import { Paper, Alert } from '@mui/material'
import * as Sentry from '@sentry/react'
import PropTypes from 'prop-types'
import { colors } from '@global/constants/colors'
import { Trans } from '@lingui/macro'
import { trackError } from 'lib/eventTracking'

const ErrorFallback = () => {
  return (
    <Paper>
      <Alert severity="error" style={{ backgroundColor: colors.red.dark, color: 'white' }}>
        <div>
          <Trans>
            Oops! It looks like something went wrong. We are already looking into it, but feel free
            to reach out to your Claravine CSM for additional support. Please refresh the page and
            try again.
          </Trans>
        </div>
      </Alert>
    </Paper>
  )
}

const ErrorPaper = props => {
  return <Paper {...props}>{props.children}</Paper>
}
ErrorPaper.propTypes = {
  children: PropTypes.node,
}

const handleError = (error, errorInfo) => {
  console.error('Error caught by ErrorBoundary:', error, errorInfo)

  trackError(error, {
    componentStack: errorInfo?.componentStack,
    errorBoundary: 'error-paper',
  })
}

export const ErrorPaperWithErrorBoundary = props => {
  return (
    <Sentry.ErrorBoundary
      fallback={<ErrorFallback />}
      beforeCapture={(_scope, error, errorInfo) => {
        handleError(error, errorInfo)
      }}
    >
      <ErrorPaper {...props} />
    </Sentry.ErrorBoundary>
  )
}
